import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SectionHeading from './SectionHeading';
import PricingPlans from '../billing/PricingPlans';
import { useT } from '../../i18n/LanguageContext';

export default function PricingSection() {
  const theme = useTheme();
  const t = useT();
  return (
    <Box id="pricing" sx={{ bgcolor: theme.home.paper, py: theme.home.sectionPy, position: 'relative' }}>
      <Box sx={{ position: 'absolute', inset: 0, backgroundImage: theme.home.grain, pointerEvents: 'none' }} />
      <Box sx={{ maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 }, position: 'relative' }}>
        <SectionHeading
          align="center"
          eyebrow={t('home.pricingSection.eyebrow')}
          title={t('home.pricingSection.title')}
          lede={t('home.pricingSection.lede')}
        />
        <Box sx={{
          mt: { xs: 4, md: 6 },
          '& .MuiCard-root': { borderRadius: 4, boxShadow: theme.home.softShadow, border: `1px solid ${theme.home.paperDeep}` },
        }}>
          <PricingPlans />
        </Box>
      </Box>
    </Box>
  );
}
